/**
 * TanStack Query hook for the firms list (SuperAdmin use).
 */

import { useQuery } from '@tanstack/react-query';
import { getFirms, type Firm } from '@/api/firms';

export const firmQueryKeys = {
  all: ['firms'] as const,
  list: () => [...firmQueryKeys.all, 'list'] as const,
};

/**
 * Fetch all active firms. Caches for 5 minutes.
 * Only enabled when the caller explicitly opts in (SuperAdmin check).
 */
export function useFirms(options?: { enabled?: boolean }) {
  return useQuery<Firm[], Error>({
    queryKey: firmQueryKeys.list(),
    queryFn: () => getFirms(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: options?.enabled ?? true,
  });
}

export type { Firm } from '@/api/firms';
